import {z} from 'zod';

export const standardPlaybackControlSchema = z.enum([
  'play',
  'pause',
  'resume',
  'reverse',
  'reverseFlipEase',
  'restart',
  'stop',
  'none',
  'togglePlayReverse',
  'togglePlayReverseFlipEase',
]);
export type StandardPlaybackControl = z.infer<
  typeof standardPlaybackControlSchema
>;

export const timelineControlTypeSchema = z.enum([
  'standard',
  'scroll',
  'load',
  'continuous',
]);
